module.exports = "input[type=\"text\"]{\r\n\tbackground-color:#002E5D;\r\n\theight:35px;\r\n\tmargin-bottom:4px;\r\n\tcolor:white;\r\n}\r\nbutton{\r\n\tbackground-color:#002E5D;\r\n\tcolor:white;\r\n\theight: 30px;\r\n\tborder:0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/trabalhe-conosco/trabalhe-conosco.component.css
// module id = ./src/app/trabalhe-conosco/trabalhe-conosco.component.css
// module chunks = main